/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Guide_No_License_TitleInputs */

const es_marketplace_seo_spain_guide_no_license_title = /** @type {(inputs: Marketplace_Seo_Spain_Guide_No_License_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alquiler de barco sin licencia ni carnet`)
};

const gl_marketplace_seo_spain_guide_no_license_title = /** @type {(inputs: Marketplace_Seo_Spain_Guide_No_License_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alugueiro de barco sen licenza nin carnet`)
};

const en_marketplace_seo_spain_guide_no_license_title = /** @type {(inputs: Marketplace_Seo_Spain_Guide_No_License_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boat rental without a licence`)
};

/**
* | output |
* | --- |
* | "Boat rental without a licence" |
*
* @param {Marketplace_Seo_Spain_Guide_No_License_TitleInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_guide_no_license_title = /** @type {((inputs?: Marketplace_Seo_Spain_Guide_No_License_TitleInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Guide_No_License_TitleInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_guide_no_license_title(inputs)
	if (locale === "en") return en_marketplace_seo_spain_guide_no_license_title(inputs)
	return es_marketplace_seo_spain_guide_no_license_title(inputs)
});